export default {
	searchQuery: null,
	participantsQuery: null,
	durationsQuery: null,
	categoriesQuery: null
}
